import Vue from 'vue'
import SvgIcon from '@/components/SvgIcon'

// 全局注册组件
Vue.component('svg-icon', SvgIcon)

// 自动导入所有 svg
const req = require.context('./svg', false, /\.svg$/)
const requireAll = c => c.keys().map(c)
requireAll(req)